import { User } from "../../../domain/User";
import { Badge, ButtonIcon, Poptip, Table } from "@optimizely/axiom";
import React from "react";
import { ExternalUserIndicator } from "../ExternalUserIndicator/ExternalUserIndicator";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Flags } from "../../../feature-flags/flags";
import classNames from "classnames";

type UserTableRowProps = {
    onRemove?: () => void;
    removeTitle?: string;
    showExternal?: boolean;
    user: User;
};
export const UserTableRow = ({
    onRemove,
    removeTitle = "Remove user",
    showExternal = false,
    user
}: UserTableRowProps) => {
    const { enabled: enableRebrand } = useFeatureFlag(Flags.ENABLE_REBRAND);
    const classes = classNames({
        "label--disabled": !onRemove
    });
    return (
        <Table.TR className={classes}>
            <Table.TD className="truncated" colSpan={3}>
                {`${user.firstName} ${user.lastName}`} ({user.email})
                {showExternal &&
                    (enableRebrand ? (
                        <Badge className="oui-badge--external push--left">External</Badge>
                    ) : (
                        <ExternalUserIndicator fill={!onRemove ? "#707070" : "#080736"} className="push--left" />
                    ))}
            </Table.TD>
            {!!onRemove && (
                <Table.TD textAlign="right">
                    <Poptip isInline trigger="mouseenter" content={removeTitle} className="">
                        {/* eslint-disable react/style-prop-object */}
                        <ButtonIcon
                            data-cy={`remove-${user.email}-button`}
                            iconName="trash-can"
                            size="small"
                            style="plain"
                            title=""
                            onClick={onRemove}
                        />
                    </Poptip>
                </Table.TD>
            )}
        </Table.TR>
    );
};

UserTableRow.displayName = "UserTableRow";
